var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarIconProjectYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "#FFD439",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.73298 13.4658L9.5 13.3431L9.26702 13.4658L4.33841 16.0614L5.42941 10.8947L5.49014 10.6071L5.26837 10.4142L1.18776 6.86422L6.73699 6.24503L7.00969 6.2146L7.13049 5.96824L9.5 1.13571L11.8695 5.96824L11.9903 6.2146L12.263 6.24503L17.8122 6.86422L13.7316 10.4142L13.5099 10.6071L13.5706 10.8947L14.6616 16.0614L9.73298 13.4658Z",
    stroke: "#FFD439"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIconProjectYellow);
export default __webpack_public_path__ + "static/media/starIconProjectYellow.3bc80a68339801b15cedf4de2b99138d.svg";
export { ForwardRef as ReactComponent };